import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return []

    return data.resources.map(option => ({
      ...option,
      id: option.type,
      text: option.name,
    }))
  }, [data])
}
